import React from "react"

export const PeopleIcon = ({ height = "1rem", clickFunction = () => {}}) => <svg
    className="svg"
    onClick={clickFunction}
    style={{height: height}}
    xmlns="http://www.w3.org/2000/svg" viewBox="0 -8 32 32">
    <g fill="none">
        <path d="M20 8a4 4 0 1 1-8 0a4 4 0 0 1 8 0zM7 12a3 3 0 1 0 0-6a3 3 0 0 0 0 6zm18 0a3 3 0 1 0 0-6a3 3 0 0 0 0 6zm-14.778 3.025A1.923 1.923 0 0 1 11.923 14h8.154A1.923 1.923 0 0 1 22 15.923V22a6.003 6.003 0 0 1-11.846 1.355A6.019 6.019 0 0 1 10 22v-6.077c0-.324.08-.63.222-.898zm-1.722.898c0-.32.044-.63.126-.923H4a1 1 0 0 0-1 1v5a4 4 0 0 0 5.929 3.505A7.488 7.488 0 0 1 8.5 22v-6.077zM23.5 22a7.49 7.49 0 0 1-.429 2.505A4 4 0 0 0 29 21v-5a1 1 0 0 0-1-1h-4.626c.082.294.126.603.126.923V22z" fill="currentColor"></path>
    </g>
</svg>
